var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScaleoutSystem(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 166,
    viewBox: "0 0 160 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 85.9884,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9908 52.7119C80.6217 52.7119 78.7024 54.6312 78.7024 57.0003C78.7024 59.3694 80.6217 61.2887 82.9908 61.2887C85.3599 61.2887 87.2791 59.3694 87.2791 57.0003C87.2791 54.6312 85.3599 52.7119 82.9908 52.7119Z",
    fill: "#A6B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6249 36.0088C72.1092 35.679 62.6328 44.6156 62.063 55.9213L56.3052 63.5984C55.5555 64.588 56.2752 65.9975 57.5048 65.9975H62.0031V74.9941C62.0031 78.2928 64.702 80.9918 68.0008 80.9918H70.9997V86.9895C70.9997 88.6389 72.3491 89.9884 73.9985 89.9884H88.9928C90.6422 89.9884 91.9917 88.6389 91.9917 86.9895V75.9537C99.3089 72.475 104.287 64.9179 103.987 56.2212C103.567 45.3653 94.4508 36.3387 83.6249 36.0088ZM91.9917 57.0009C91.9917 57.3907 91.9617 57.7806 91.9317 58.1705L94.4208 60.1497C94.6607 60.3296 94.7207 60.6295 94.5707 60.8994L92.1716 65.0678C92.0217 65.3377 91.6918 65.4277 91.4519 65.3377L88.483 64.1382C87.8533 64.618 87.1935 65.0079 86.4738 65.3077L85.994 68.4865C85.964 68.7864 85.6941 68.9963 85.3942 68.9963H80.596C80.2961 68.9963 80.0562 68.7864 79.9962 68.4865L79.5464 65.3077C78.7967 65.0079 78.1369 64.618 77.5072 64.1382L74.5383 65.3377C74.2684 65.4277 73.9385 65.3377 73.7886 65.0678L71.3895 60.8994C71.2396 60.6595 71.2995 60.3296 71.5394 60.1497L74.0585 58.1705C74.0285 57.7806 73.9985 57.3907 73.9985 57.0009C73.9985 56.611 74.0585 56.1912 74.1185 55.8313L71.5694 53.8521C71.3295 53.6722 71.2695 53.3723 71.4195 53.0724L73.8186 48.934C73.9685 48.6641 74.2684 48.5741 74.5383 48.6641L77.5372 49.8636C78.1369 49.4138 78.8267 48.9939 79.5464 48.694L79.9962 45.5152C80.0562 45.2154 80.2961 45.0054 80.596 45.0054H85.3942C85.6941 45.0054 85.934 45.2154 85.994 45.5152L86.4438 48.694C87.1635 48.9939 87.8233 49.3838 88.453 49.8636L91.4519 48.6641C91.7218 48.5741 92.0517 48.6641 92.1716 48.934L94.5707 53.0724C94.7207 53.3423 94.6607 53.6722 94.4208 53.8521L91.8717 55.8313C91.9617 56.1912 91.9917 56.5811 91.9917 57.0009Z",
    fill: "#A6B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 165.988,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleoutSystem);
export default __webpack_public_path__ + "static/media/Scaleout-system.305c2c460dc50a3272f689d35fabe9eb.svg";
export { ForwardRef as ReactComponent };